import { Component, ChangeDetectionStrategy, ChangeDetectorRef, HostBinding } from '@angular/core';
import { FormBaseComponent } from '../../models/form-base-component';
import { FormSelectField} from './form-select.model';
import { FormFieldService } from '../../services/form-field.service';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'gio-form-select',
  templateUrl: './form-select.component.html',
  styleUrls: ['./form-select.component.scss'],
  host: {
    '[class]': 'classNames'
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormSelectComponent<N = any> extends FormBaseComponent<FormSelectField<N>> {
  @HostBinding('style')
  get myStyle() { return this.getHostStyles(); }

  constructor(
    private cd: ChangeDetectorRef,
    public _service: FormFieldService,
    sanitizer: DomSanitizer
  ) { super(cd, _service, sanitizer); }

  onComponentInit() {

    this.subscribe = this.service.detectChanges$.subscribe(() => {
      this.cd.detectChanges();
    })

  }
  onComponentDestroy() { }

}
